import { useTranslation } from "react-i18next";
import SkynetForm from "../../../Fundamentals/Form/SkynetForm";
import ComboBox, { POSITIONING_STRATEGY } from "../../../Fundamentals/ComboBox";
import DatePicker from '../../../Fundamentals/DatePicker';
import AlertSmall from "../../../AlertSmall";

export default function CreateCustomerDiscountAgreementForm({ form, onChange, groupedDiscountAgreements }) {
    const { t } = useTranslation();

    const handleDiscountAgreementChange = (value) => {
        onChange(value, "discountAgreementId");

        if (groupedDiscountAgreements && value) {
            const selectedGroup = Object.values(groupedDiscountAgreements).find(group => group.id === value);

            if (selectedGroup && selectedGroup.discountAgreements) {
                const groupedIds = selectedGroup.discountAgreements.map(agreement => agreement.id);
                onChange(groupedIds, "groupedDiscountAgreementIds");
            }
        }
    };

    if (!form || !form.data)
        return;

    return <SkynetForm>
        <fieldset className="d-grid col-12 gap-12">
            <ComboBox required label={t('createCustomerDiscountAgreementForm.discount')} options={groupedDiscountAgreements} value={form.data.discountAgreementId} onChange={handleDiscountAgreementChange} valueKey="id" labelKey="name" strategy={POSITIONING_STRATEGY.DIALOG} />
            <DatePicker required showTime={false} label={t('common.startdate')} value={form.data.startDate} onChange={(value) => onChange(value, "startDate")} />
            <DatePicker required showTime={false} label={t('common.enddate')} value={form.data.endDate} onChange={(value) => onChange(value, "endDate")} />
            {form.data.groupedDiscountAgreementIds && form.data.groupedDiscountAgreementIds.length > 1 && (
                <AlertSmall alert={{
                    type: "info",
                    message: t('createCustomerDiscountAgreementForm.multipleDiscountsApplied', { count: form.data.groupedDiscountAgreementIds.length })
                }} />
            )}
        </fieldset>
    </SkynetForm>;
}